import { Close } from "@mui/icons-material";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  IconButton,
  Radio,
  RadioGroup,
  styled,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import featureServer from "../../../FeatureServer/featureServer";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& h2": {
    background: theme.palette.primary.main,
    color: "#fff",
    fontWeight: "500",
  },
}));

const NotifyOrder = (props) => {
  const [dialogDetails, setDialogDetails] = useState({
    open: true,
    success: false,
    notify: "",
    emailValue: true,
    phoneValue: true,
    invoiceOrder: false,
    printTaxInvoice: false,
    emailTaxInvoice: false,
    showChildCheckboxes: false,
  });

  useEffect(() => {
    props.callbackNotify(dialogDetails);
  }, [dialogDetails]);

  const handleClose = () => {
    setDialogDetails({
      ...dialogDetails,
      open: false,
    });
  };

  const handleSubmit = () => {
    setDialogDetails({
      ...dialogDetails,
      success: true,
      open: false,
    });
  };

  const handleEmailValue = (e) => {
    setDialogDetails({
      ...dialogDetails,
      emailValue: e.target.checked,
    });
  };

  const handlePhoneValue = (e) => {
    setDialogDetails({
      ...dialogDetails,
      phoneValue: e.target.checked,
    });
  };

  const handleParentChange = (e) => {
    const isChecked = e.target.checked;
    setDialogDetails((prev) => ({
      ...prev,
      showChildCheckboxes: isChecked,
      invoiceOrder: isChecked,
    }));
  };

  const handleChildChange = (key) => (e) => {
    setDialogDetails((prev) => ({
      ...prev,
      [key]: e.target.checked,
    }));
    // if (key === "printTaxInvoice" && e.target.checked === true) {
    //   props.handlePrintTaxInvoice("PrintA4", props.orderDetails)
    // }
  };

  return (
    <StyledDialog
      open={dialogDetails.open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {dialogDetails.notify
          ? "Notify & Ready to Fulfill"
          : "Ready to Fulfill"}
        <IconButton onClick={handleClose}>
          <Close style={{ color: "#fff" }} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {props.orderDetails.dlvmode === "CC_Pickup" &&
          (props.orderDetails.customer.email !== "" ||
            props.orderDetails.clientEmail !== "" ||
            props.orderDetails.customer.mobile !== "" ||
            props.orderDetails.shipcarrierdeliverycontact !== "")
          ? (
            <Box p={2}>
              Select option to notify to Fulfill the order.

              <FormGroup>
                {(props.orderDetails.customer.email || props.orderDetails.clientEmail) && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={dialogDetails.emailValue}
                        onChange={handleEmailValue}
                      />
                    }
                    label="Email"
                  />
                )}
                {(props.orderDetails.customer.mobile || props.orderDetails.shipcarrierdeliverycontact) && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={dialogDetails.phoneValue}
                        onChange={handlePhoneValue}
                      />
                    }
                    label="Phone Number"
                  />
                )}
                {featureServer && <FormControlLabel
                  control={
                    <Checkbox
                      checked={dialogDetails.showChildCheckboxes}
                      onChange={handleParentChange}
                    />
                  }
                  label="Invoice Order"
                />
                }
                {dialogDetails.showChildCheckboxes && (
                  <Box sx={{ ml: 3 }}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={dialogDetails.printTaxInvoice}
                            onChange={handleChildChange('printTaxInvoice')}
                          />
                        }
                        label="Print Tax Invoice"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={dialogDetails.emailTaxInvoice}
                            onChange={handleChildChange('emailTaxInvoice')}
                          />
                        }
                        label="Email Tax Invoice"
                      />
                    </FormGroup>
                  </Box>
                )}
              </FormGroup>
            </Box>
          ) : (
            <Box p={2}>Are you sure you want to fulfill the order?
              <FormGroup>
              {featureServer && <FormControlLabel
                  control={
                    <Checkbox
                      checked={dialogDetails.showChildCheckboxes}
                      onChange={handleParentChange}
                    />
                  }
                  label="Invoice Order"
                />
                }
                {dialogDetails.showChildCheckboxes && (
                  <Box sx={{ ml: 3 }}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={dialogDetails.printTaxInvoice}
                            onChange={handleChildChange('printTaxInvoice')}
                          />
                        }
                        label="Print Tax Invoice"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={dialogDetails.emailTaxInvoice}
                            onChange={handleChildChange('emailTaxInvoice')}
                          />
                        }
                        label="Email Tax Invoice"
                      />
                    </FormGroup>
                  </Box>
                )}
              </FormGroup>
            </Box>
          )}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          style={{ marginLeft: "10px" }}
        // disabled={(props.orderDetails.customer.email !== "" || props.orderDetails.customer.mobile !== "") ?  (dialogDetails.notify === "" ? true : false) : false}
        >
          {/* {(props.orderDetails.customer.email !== "" || props.orderDetails.customer.mobile !== "") ? "Notify & Ready to Fulfill" : "Ready to Fulfill"} */}
          {dialogDetails.notify
            ? "Notify & Ready to Fulfill"
            : "Ready to Fulfill"}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default NotifyOrder;
